import { MailListViewState } from '../store/schema/MailListViewState';
import { getSelectedTableView, LoadErrorStatus } from 'owa-mail-list-store';

// Gets the MailList Loading, loaded, Error states
export default function getMailListLoadState(): MailListViewState {
    const tableView = getSelectedTableView();

    if (!tableView || !tableView.isInitialLoadComplete) {
        return MailListViewState.Loading;
    }

    const isTableEmpty = tableView.rowKeys.length == 0;

    // do not display error if there're cached items in the table to show;
    // when error occurs and the table is truly empty, prioritize showing error instead
    // of no items in the list view
    if (tableView.loadErrorStatus != LoadErrorStatus.None && isTableEmpty) {
        return MailListViewState.Error;
    }

    if (isTableEmpty) {
        return MailListViewState.Empty;
    }

    return MailListViewState.Loaded;
}
